import { useQuery } from "@tanstack/react-query";
import { callFunction } from "../lib/api";
import { mapMatch, MatchRow } from "../lib/match";
import { Match } from "../types";

const getMatches = async (): Promise<Match[]> => {
  const data = (await callFunction("/get-matches")) as MatchRow[];
  return (data || []).map(mapMatch);
};

export const useGetMatches = () => {
  return useQuery({
    queryKey: ["matches"],
    queryFn: getMatches,
  });
};
